import WorldClassLogo from './WorldClassLogo.png';
import BeFitLogo from './BeFitLogo.png';
import { IS_BE_FIT } from '../../config/branding';

export { ReactComponent as GoosfrabaLogotype } from './GoosfrabaLogotype.svg'
export { WorldClassLogo, BeFitLogo };
export const BrandLogo = IS_BE_FIT ? BeFitLogo : WorldClassLogo;